// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"d5d64b12","383":"bb98f00d","414":"4b8ec011","544":"1933d6b2","708":"fb070970","991":"070222c0"}[chunkId] + ".chunk.css";
};